import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { availableServices } from "./available-services";

export const biddingSupportService = {
  // logo: 'assets/svgs/nbg-logo-black.svg',
  title: 'bidding.title',
  img: '../../../../assets/img/services/BiddingSupportCover.svg',
  reportSampleDocumentName: 'Bidding-Support-Template',
  descPart1: `bidding.descriptionPart1`,
  descPart2Title: 'bidding.descriptionPart2-title',
  descPart2: `bidding.descriptionPart2`,
  descPart3Title: 'bidding.descriptionPart3-title',
  descPart3: `bidding.descriptionPart3`,
  section1Title: 'whyChooseService',
  deliveryDays: 30,
  serviceFee: 100,
  whyChooseService: [
    {
      icon: 'icon-auction',
      title: 'bidding.whyChoose.title1',
      description: 'bidding.whyChoose.description1'
    },
    {
      icon: 'icon-key',
      title: 'bidding.whyChoose.title2',
      description: 'bidding.whyChoose.description2'
    },
  ],
  section2Title: 'nextSteps',
  nextSteps: [
    'bidding.nextSteps1',
    'bidding.nextSteps2',
    'bidding.nextSteps3',
    'bidding.nextSteps4'
  ],
  section3Title: 'lookAtTheseServices.title',
  section3Description: 'lookAtTheseServices.description',
  services: availableServices.filter((service) => service.type !== UnikoServiceTypes.biddingSupport),
  requestServiceButtonLabel: 'bidding.requestBidding',
}
